module.exports = __webpack_public_path__ + "28ccab1f1d376a33d9689ce1b6bcb20d.MP3";